import React, { useEffect, useState } from 'react';
import { TableLayout } from '../../containers/Layout';
import { TableRow, TableCell, TableHead, TableBody } from '@material-ui/core';
import { fetchTransferDetailsTmp, singleTransferGet } from '../../../../../../../../jsx/actions/transferAction';
import SingleTransferTemplate from '../singleTemplates/SingleTransferTemplate';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash-es';
import DispatchResaDemandTransfer from './DispatchResaDemandTransfer';

// resa_demand_id = "a3a52848-2384-4e3d-b0a2-8b649a2ffbfb"
const SingleTransferResa = (props) => {
    const dispatch = useDispatch();
    const [resa, setResa] = useState({});
    const [openDispatch, setOpenDispatch] = useState({});

    useEffect(() => {
        fetchTransferData();
    }, [dispatch, props.resa.id]);

    const fetchTransferData = async () => {
        try {
            const resaData = await dispatch(fetchTransferDetailsTmp(props.resa.id, "resa/transfer"));
            console.log("Update fetchTransferData",resaData,"vs",resa,"for",props.resa.id)
            setResa(resaData);
        } catch (error) {
            console.error('Error fetching resa details:', error);
        }
    };


    const { shop, client, notif } = props;

    const validateResa = async () => {
       await dispatch(singleTransferGet(resa.id, "transfer/resa/validate"));
       fetchTransferData();
    };

    return (
        <>
           
            <SingleTransferTemplate
                shop={shop} 
                client={client} 
                transfer={resa} 
                notif={notif}
                // handleResaToSale={handleResaToSale}
                handleManageResa={() => setOpenDispatch(true)}
            >
                {/* <div>
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                            <TableCell className="text-left">Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {createProductList()}
                            <TableRow>
                            <TableCell colSpan={2}></TableCell>
                            </TableRow>
                        </TableBody>
                    </TableLayout>
                </div> */}
                <DispatchResaDemandTransfer
                    // {...this.props}
                    resa={resa}
                    fetchTransferData={fetchTransferData}
                    validateResa={validateResa}
                    handleClose={ () => setOpenDispatch(false) }
                    //refetchStocks={refetchStocks}
                />
            </SingleTransferTemplate>
        </>
    );
};

export default SingleTransferResa;
